const fadeTime = 300;

const fadeOut = (target) => {
	target.style.opacity = 1;
	target.style.translate = 0;
	target.style.transition = `all ${fadeTime}ms`;
	target.style.opacity = 0;
	target.style.translate = "0 10px";

	setTimeout(() => {
		target.style.display = "none";
	}, fadeTime);
};

const fadeIn = (target) => {
	target.style.opacity = 0;
	target.style.translate = "0 10px";
	target.style.transition = `all ${fadeTime}ms`;
	target.style.opacity = 1;
	target.style.translate = 0;

	setTimeout(() => {
		target.style.display = "block";
	}, fadeTime);
};

const setActive = (el) => {
	[...el.parentElement.children].forEach((sib) => sib.classList.remove("is-active"));
	el.classList.add("is-active");
};

const setCSSVar = (name, value, target = "body") => {
	const element = target === "html" ? document.documentElement : document.body;
	element.style.setProperty(name, value);
};

const isInViewport = (element) => {
	var rect = element.getBoundingClientRect();
	var html = document.documentElement;
	return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || html.clientHeight) && rect.right <= (window.innerWidth || html.clientWidth);
};

const debounce = (fn, wait) => {
	let timeout;
	return function (...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => fn.apply(this, args), wait);
	};
};

const throttle = (fn, limit) => {
	let waiting = false;
	return function (...args) {
		if (!waiting) {
			fn.apply(this, args);
			waiting = true;
			setTimeout(() => {
				waiting = false;
			}, limit);
		}
	};
};

const getContainerPosLeft = (selector = ".wrapper") => {
	const main = document.querySelector(".main");
	const container = main?.querySelector(selector);

	if (!main || !container) return;

	const containerLeft = container.getBoundingClientRect().left;
	const style = getComputedStyle(container);
	const gutter = parseFloat(style.paddingInlineStart);

	setCSSVar("--_offset-x-start", `${containerLeft}px`);
	setCSSVar("--_gutter", `${gutter}px`);

	return containerLeft + gutter;
};

/** Hauteur utile du header (barre `.header__inner`, sans la zone mobile ouverte). */
const getHeaderHeight = () => {
	const headerInner = document.querySelector(".header__inner");
	return headerInner ? headerInner.offsetHeight : 0;
};

/**
 * Met à jour les custom properties liées au header (recalcul après resize, menu, etc.).
 * @returns {number} hauteur en px, ou 0 si aucun `.header__inner`
 */
const updateHeaderOffsetVars = () => {
	const h = getHeaderHeight();
	if (!h) {
		return 0;
	}
	setCSSVar("--offset-header", `${h}px`);
	setCSSVar("--header-height", `${h}px`);
	return h;
};

// Fonction pour mettre à jour les variables de mise en page
const updateLayoutVars = () => {
	updateHeaderOffsetVars();
	getContainerPosLeft();
};

export {
	fadeOut,
	fadeIn,
	fadeTime,
	setActive,
	setCSSVar,
	isInViewport,
	debounce,
	throttle,
	getContainerPosLeft,
	getHeaderHeight,
	updateHeaderOffsetVars,
	updateLayoutVars,
};
